import { useMemo } from 'react';
import { DataRoomNode } from '../models/DataRoomNode';
import { getIsFolderEmpty } from 'utils';

const useDataRoomNodeAutorized = (nodes: DataRoomNode[]) => {
  const shouldNotManage = useMemo(() => nodes.every(getIsFolderEmpty), [nodes]);

  const hasAuthorizedActionsForAll = useMemo(
    () => nodes.every(({ hasAuthorizedActions }) => hasAuthorizedActions),
    [nodes],
  );

  return {
    shouldNotManage,
    hasAuthorizedActionsForAll,
  };
};

export default useDataRoomNodeAutorized;
